/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isenabled1Inputs */

const en_entity_isenabled1 = /** @type {(inputs: Entity_Isenabled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Enabled`)
};

const de_entity_isenabled1 = /** @type {(inputs: Entity_Isenabled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist aktiviert`)
};

/**
* | output |
* | --- |
* | "Is Enabled" |
*
* @param {Entity_Isenabled1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isenabled1 = /** @type {((inputs?: Entity_Isenabled1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isenabled1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isenabled1(inputs)
	return de_entity_isenabled1(inputs)
});
export { entity_isenabled1 as "entity_isEnabled" }